/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/components/SampleSizeSection.tsx.
 */

import React from "react";
import "../UserHome.css";

const SampleSizeSection: React.FC = () => {
  return (
    <div className="user-home-section">
      <div className="user-info-card">
        <h3 className="user-info-card-title">Sample size and result validity</h3>
        <p className="user-info-card-text">
          Based on your selected inputs, the platform displays:
        </p>
        <p className="user-info-card-text">
          The number of datasets retrieved for:
        </p>
        <ul className="user-info-list">
          <li>Reliability + Generic specificity pool</li>
          <li>Reliability + Defined specificity pool</li>
        </ul>
        <p className="user-info-card-text">
          If the sample size is insufficient:
        </p>
        <ul className="user-info-list">
          <li>The system will prompt you to adjust input parameters</li>
        </ul>
        <p className="user-info-card-text">
          This ensures statistically meaningful and transparent results.
        </p>
      </div>
    </div>
  );
};

/** React component — Sample Size Section. */
export default SampleSizeSection;
